import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { Row, Col, Container, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import LogoSvg from '../../assets/icons/LogoSvg'
import RulesRedSvg from '../../assets/icons/RulesRedSvg'
import Modal from '../../components/MyModal/MyModal'
import './Header.css'
import RulesModalBody from './RulesModalBody'

const Header = ({ backButton = true, onClick, rules = false }) => {
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState()

  const toggle = () => setOpenModal(!openModal)

  return (
    <Container>
      <Row style={{ minWidth: '100%', minHeight: '2.5rem' }} />
      <Row
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
      >
        {backButton ? (
          <Col>
            <Button
              onClick={onClick}
              style={{
                display: 'flex',
                justifyContent: 'center',
                border: 'none',
                backgroundColor: '#fff',
                margin: '0 0 0 -.5rem',
              }}
            >
              <FontAwesomeIcon
                style={{
                  backgroundColor: '#EFEFEF',
                  alignItems: 'center',
                  color: '#285843',
                  borderRadius: '50px',
                  padding: '0.7rem',
                  height: '0.7rem',
                  width: '0.7rem',
                }}
                icon={faChevronLeft}
                size='sm'
              />
            </Button>
          </Col>
        ) : (
          <Col>
            <div style={{ width: '100%' }}></div>
          </Col>
        )}
        <Col
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '1rem',
          }}
        >
          <Button
            className='logo'
            onClick={(e) => {
              e.stopPropagation()
              navigate('/')
            }}
            style={{ backgroundColor: 'inherit', borderStyle: 'none' }}
          >
            <LogoSvg width={'7rem'} />
          </Button>
        </Col>
        <Col>
          {rules ? (
            <div
              onClick={toggle}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'end',
                alignItems: 'end',
                margin: '1rem 0 0 0',
              }}
            >
              <div style={{ margin: '0 .5rem 0 0' }}>
                <RulesRedSvg width={'1.7rem'} />
              </div>
              <div style={{ fontSize: '13px', fontWeight: '300' }}>Kurallar</div>
            </div>
          ) : (
            <div style={{ width: '100%' }}></div>
          )}
        </Col>
      </Row>
      <Modal toggle={toggle} modal={openModal} closeButton={false} body={<RulesModalBody />} setHeight={'auto'} />
    </Container>
  )
}

Header.propTypes = {
  backButton: PropTypes.bool,
}

export default Header
